var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 17.625,
    viewBox: "0 0 16 17.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1012",
    "data-name": "Rectangle 1012",
    width: 16,
    height: 17.625,
    fill: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bin",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2723",
    "data-name": "Group 2723",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M15.31,3.249H11.939V2.316A2.317,2.317,0,0,0,9.625,0H6.376A2.318,2.318,0,0,0,4.061,2.316v.933H.69a.691.691,0,0,0,0,1.382h.934V15.311a2.317,2.317,0,0,0,2.315,2.315h8.122a2.317,2.317,0,0,0,2.314-2.315V4.63h.935a.691.691,0,0,0,0-1.382M5.441,2.316a.935.935,0,0,1,.935-.934H9.625a.935.935,0,0,1,.934.934v.933H5.441Zm7.554,13a.936.936,0,0,1-.934.934H3.939A.936.936,0,0,1,3,15.311V4.63H13Z",
    transform: "translate(0 0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M7.69,9A.69.69,0,0,0,7,9.69v4.874a.69.69,0,0,0,1.381,0V9.69A.69.69,0,0,0,7.69,9",
    transform: "translate(-1.314 -1.69)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M11.69,9a.69.69,0,0,0-.69.69v4.874a.69.69,0,0,0,1.381,0V9.69A.69.69,0,0,0,11.69,9",
    transform: "translate(-2.066 -1.69)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/Bin.2d94c0325a53b40a725697e29067010e.svg";
export { ForwardRef as ReactComponent };